import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/configuracoes/calendario')({
  component: lazyRouteComponent(
    () => import('@/features/configuracoes/components/calendario-tab'),
    'CalendarioTab',
  ),
})
